import { TextSelection, } from '@tencent/exeditor3-core';
import { newlineInCode } from 'prosemirror-commands';
import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
export class CodeBlockPlugin {
    constructor() {
        this.name = 'codeBlock';
        this.priority = 75;
        this.spec = {
            type: 'node',
            childrenType: 'text*',
            matchSelector: 'pre, [data-ex-plugin="code-block"]',
            matchOptions: { preserveWhitespace: 'full' },
            toDOM: { tag: 'pre', children: { tag: 'code', children: true } },
            defining: true,
            code: true,
            marks: '',
        };
        this.toggle = () => {
            const isActive = this.editor.isActive(this);
            if (isActive) {
                this.editor.selection().unwrapLines();
            }
            else {
                this.editor.selection(true).wrapLines(this.name);
            }
        };
        this.escapeCodeBlock = (state, dispatch) => {
            const { tr, selection, schema } = state;
            // 保证光标为空且在代码块内
            if (!selection.empty || selection.$from.parent.type.name !== this.name) {
                return false;
            }
            // 找到所在代码块的位置
            const codeBlockPos = selection.$from.before();
            // 保证光标在代码块尾部
            const codeBlockEnd = codeBlockPos + selection.$from.parent.nodeSize;
            if (selection.from !== codeBlockEnd - 1) {
                return false;
            }
            if (!/\n{2}$/.test(selection.$from.parent.textContent)) {
                return false;
            }
            // 插入空段，并删除代码块末尾两个换行
            tr.insert(codeBlockEnd, schema.nodes.paragraph.create());
            tr.delete(codeBlockEnd - 3, codeBlockEnd - 1);
            tr.setSelection(TextSelection.create(tr.doc, tr.mapping.map(codeBlockEnd) - 1));
            dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
            return true;
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                toggle: this.toggle,
            },
            shortcuts: {
                Enter: [this.escapeCodeBlock, newlineInCode],
            },
            transformHTML: (html, event) => {
                var _a, _b;
                const vscodeEditorData = (_b = (_a = event === null || event === void 0 ? void 0 : event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData) === null || _b === void 0 ? void 0 : _b.call(_a, 'vscode-editor-data');
                if (vscodeEditorData) {
                    const dataConfig = JSON.parse(vscodeEditorData);
                    if (dataConfig.mode) {
                        return html
                            .replace(/(<meta.+?<div)/, `$1 data-ex-plugin="code-block"`)
                            .replace(/(<\/div>|<br>)/g, '$1\n');
                    }
                }
                return html;
            },
            inputRules: [
                {
                    match: /^```[\w\-+]*\s$/,
                    captureEnter: true,
                },
            ],
        };
    }
    renderToolbarItem() {
        const btn = document.createElement('exeditor-toolbar-button');
        Object.assign(btn, {
            label: this.editor.t('代码块'),
            onclick: () => {
                this.editor.focus();
                this.toggle();
            },
        }).appendChild(createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.codeBlockIcon),
        }));
        return btn;
    }
}
//# sourceMappingURL=index.js.map